

























import { Component, Vue } from 'vue-property-decorator';
import PaymentMethodNew from '@/components/PaymentMethod/PaymentMethodNew.vue';

@Component({
  components: {
    PaymentMethodNew,
  },
})
export default class PaymentMethodNewButton extends Vue {
  private showDialog = false;
}
